import { render, staticRenderFns } from "./recCode.vue?vue&type=template&id=22c776b9&"
import script from "./recCode.vue?vue&type=script&lang=js&"
export * from "./recCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports